import yall from 'yall-js';

var lazyImgObserver = {

  init: function () {
    if (typeof window.IntersectionObserver !== 'undefined') {

      yall({
        lazyBackgroundLoaded: 'lazy-bg--show',
        events: {
          load: event => {
            if (event.target.nodeName == 'IMG' && !event.target.classList.contains('lazy')) {
              event.target.classList.add('lazy--show');
            }
          }
        }
      });
    } else {
      console.warn('IntersectionObserver not supported - load all images instantly...');
      const dataSrc = document.querySelectorAll("[data-src]");
      dataSrc.forEach((el) => {
        var img = el.dataset("src");
        el.setAttribute("src", img).classList.add("lazy--show");
      });

      const dataSrcSet = document.querySelectorAll("[data-srcset]");
      dataSrcSet.forEach((el) => {
        var img = el.dataset("srcset");
        el.setAttribute("srcset", img).classList.add("lazy--show");
      })

      const lazyBg = document.querySelectorAll(".lazy-bg");
      lazyBg.forEach((el) => {
          el.classList.add("lazy-bg--show");
      });
    }
  }
};

export default lazyImgObserver;